<template>
  <section id="Enablement">
    <div class="inner">
      <h2>智能化营销获客体验</h2>
      <div class="image-switcher-wrapper">
        <div class="left">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item
              v-for="item in list2"
              :key="item.name"
              :title="item.title"
              :name="item.name"
            >
              <img src="@/assets/platform/elementor-widget-icon.svg" />
              <p>{{ item.text }}</p>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="right">
          <img :src="imageUrl" />
        </div>
      </div>
      <!--  -->
      <div class="streamlined-merchant-experience">
        <h2>一站式智能服务体验</h2>
        <div class="info">
          <p>
            一套系统、一支团队、一个生态，助力工厂与贸易商实现从“工厂好产品”到“全球好品牌”的升级跨越。
          </p>
        </div>
        <div class="icon-list">
          <div class="icon-item" v-for="item in list3" :key="item.title">
            <img :src="item.imageUrl" />
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Enablement',
  data() {
    return {
      activeName: 'Messaging',
      list2: [
        {
          name: 'Messaging',
          title: 'AI驱动选品推荐',
          imageUrl: 'enablement-list1-1.png',
          text: '基于全球平台数据与消费者偏好，Xport智能分析热门品类与蓝海市场，帮助传统工厂精准选定出海爆品，降低试错成本。'
        },
        {
          name: 'PriceAndCurrencies',
          title: '多平台营销触达',
          imageUrl: 'enablement-list1-2.png',
          text: '整合Amazon、eBay、Shopee、Lazada、TikTok Shop等全球主流平台广告系统与社媒矩阵，实现一站式广告投放与营销联动，扩大品牌声量。'
        },
        {
          name: 'CheckoutExperience',
          title: '海外KOL与社媒种草',
          imageUrl: 'enablement-list1-3.png',
          text: 'Xport提供KOL资源对接与社媒运营支持，助力产品在YouTube、Instagram、TikTok等平台实现快速曝光，打造海外种草闭环。'
        },
        {
          name: 'Shipping',
          title: '品牌独立站建设与引流',
          imageUrl: 'enablement-list1-4.png',
          text: '为B2B企业量身打造DTC独立站，配套SEO优化、站外引流、私域沉淀，打造自主品牌阵地，实现“流量自主权”。'
        },
        {
          name: 'TaxAndDuty',
          title: '精准人群画像与再营销税',
          imageUrl: 'enablement-list1-4.png',
          text: '通过大数据与AI分析用户行为，识别高潜客户群体，实现个性化推荐与再营销广告投放，提升转化效率。'
        },
        {
          name: 'PaymentOptions',
          title: '一站式广告代投与数据分析',
          imageUrl: 'enablement-list1-6.png',
          text: '专业团队代运营Facebook Ads、Google Shopping、TikTok Ads等出海营销渠道，并输出转化报表与ROI分析，助力企业科学投入。'
        },
        {
          name: 'Returns',
          title: '多语言内容与视觉本地化',
          imageUrl: 'enablement-list1-7.png',
          text: '提供多语言广告文案撰写、图片视频制作及本地审美适配，让内容真正“入乡随俗”，提升点击率与信任度。'
        },
        {
          name: 'CustomerSupport',
          title: '营销自动化与CRM对接',
          imageUrl: 'enablement-list1-8.png',
          text: '整合营销自动化工具，助力企业建立从引流、成交、复购到客户维护的完整漏斗体系，实现长期客户价值管理。'
        }
      ],
      list3: [
        {
          title: '端到端跨境电商运营支持',
          imageUrl: require('@/assets/platform/end-to-end-operations.svg'),
          text: 'Xport打通选品、平台对接、商品上架、订单履约、客服、退换货等全链条流程。通过智能化SaaS系统整合ERP与电商平台API，帮助企业实现从工厂到全球买家的高效闭环，实现一键铺货、多平台联动、自动发货，让传统工厂也能像DTC品牌一样敏捷运转。'
        },
        {
          title: '法规与税务合规解决方案',
          imageUrl: require('@/assets/platform/regulations-and-tax-compliance.svg'),
          text: '针对不同市场（如美国、欧盟、澳洲等）的进口清关、VAT/GST、商品安全标准等合规要求，Xport提供本地专家支持与自动化合规工具，协助企业完成产品标签、报关资质、跨境税号注册与税务申报，确保平台销售与清关全过程合规可控，避免因政策失误造成封店或滞货。'
        },
        {
          title: '跨境风险管理体系',
          imageUrl: require('@/assets/platform/risk-management.svg'),
          text: '从汇率波动、平台政策、物流异常、退货争议到数据安全，Xport构建了完整的风控模型：设有智能预警系统、平台政策监控工具、保险机制与纠纷调解支持，帮助卖家提前识别风险、应对突发，保障出海业务稳定运营。'
        },
        {
          title: '本地化物流与履约能力',
          imageUrl: require('@/assets/platform/merchant-support.svg'),
          text: 'Xport整合全球头程运输、海外仓储与本地配送资源，为工厂提供FBA对接、海外仓代发、一件代发、退货回收等服务，并通过物流可视化系统提供实时追踪与时效优化建议，实现低成本高时效的履约体验。'
        },
        {
          title: '客户成功与成长赋能服务',
          imageUrl: require('@/assets/platform/self-management-tools.svg'),
          text: '为B2B和工厂型客户提供定制化跨境出海成长路径：从0到1搭建B2C运营团队、进行多平台培训、设定KPI模型，配套品牌建设与客户沉淀能力，帮助企业逐步摆脱低价贴牌，构建属于自己的全球品牌资产。'
        }
      ]
    }
  },
  computed: {
    imageUrl() {
      let item = this.list2.find(item => item.name === this.activeName)
      return require(`@/assets/platform/${item.imageUrl}`)
    }
  },
  methods: {}
}
</script>

<style scoped lang="less">
#Enablement {
  padding: 0 5%;
  background-color: #fff;
  .inner {
    max-width: 1140px;
    margin: 0 auto;
    padding-top: 175px;
    h2 {
      font-size: 36px;
      text-align: center;
    }
    .image-switcher-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 150px;
      .left {
        flex: 1;
        margin-right: 58px;

        ::v-deep(.el-collapse) {
          border: none;
          .el-collapse-item__header {
            font-size: 18px;
            color: #bfc0c1;
            border: none;
          }
          .is-active {
            color: #000;
          }
          p {
            font-size: 16px;
          }
        }
      }
      .right {
        flex: 1;
        position: relative;
        // width: 601.67px;
        height: 601.67px;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: url(../../../assets/platform/enablement-list1-bg.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          opacity: 0.2;
        }
        img {
          max-width: 80%;
          max-height: 80%;
          border-radius: 10px;
          z-index: 1;
        }
      }
    }
    .streamlined-merchant-experience {
      h2 {
        font-size: 36px;
      }
      .info {
        padding: 20px 0;
        p {
          width: 555px;
          margin: 0 auto;
          text-align: center;
        }
      }
      .icon-list {
        min-height: 350px;
        padding-top: 60px;
        display: flex;
        align-items: start;
        justify-content: space-between;
        .icon-item {
          flex: 1;
          padding: 10px;
          text-align: center;
          img {
            width: 110px;
            height: 110px;
            max-height: 110px;
            opacity: 1;
            transition: all 0.5s ease;
          }
          h3 {
            margin: 20px 0;
            font-size: 20px;
          }
          p {
            width: 100%;
            max-height: 0;
            opacity: 0;
            transition: all 0.5s;
          }
          &:hover {
            img {
              max-height: 0;
              opacity: 0;
            }
            p {
              max-height: 280px;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
